<template>
  <el-col :span="24" align="middle" id="login" v-loading="loading" element-loading-text='Authenticating...'>
    <el-row type="flex" justify="start" align="middle" class="login-form-wrapper">
      <el-col :span="12" class="left-padded left-aligned-col">
        <el-row type="flex">
          <el-col :span="8"></el-col>
          <el-col :span="16">
            <el-row type="flex" justify="start" align="middle">
              <div class="grid-content login-row">
                <h3>Login</h3>
              </div>
            </el-row>
            <el-row type="flex" justify="start" align="middle" gutter="10" class="v-padded-s" v-if="instances && instances.length">
              <!-- <el-col :span="3" class="right-aligned-col">
                <el-input value="https://" disabled/>
              </el-col> -->
              <el-col :span="16" class="right-aligned-col">
                <el-select style="width: 100%;" v-model="instance" placeholder="Select an instance">
                  <el-option v-for="(v, i) in sortedInstances" :key="i" style="padding: 0;" :label="v.name" :value="v.url">
                    <el-row type="flex" align="middle" style="height: 36px; padding: 0 10px;">
                      <el-col style="height: 36px;" :span="21">
                        <div @click="handleInstanceSelect(v.url)" style="display: table; height: 36px; width: 100%;">
                          <span style="display: table-cell; vertical-align: middle; width: 100%;">
                            {{ v.name || v.url }}
                          </span>
                        </div>
                      </el-col>
                      <el-col :span="3">
                        <el-row type="flex" align="middle" justify="end">
                          <el-button size="mini" icon="close" style="z-index: 1000;" @click="removeInstance(v.url)" />
                        </el-row>
                      </el-col>
                    </el-row>
                  </el-option>
                  <el-option key="custom" label="Custom URL" style="padding: 0;" value="custom">
                    <el-row type="flex" align="middle" style="height: 36px;">
                      <div @click="addingCustomInstance = true" style="display: table; height: 36px; width: 100%; padding: 0 10px;">
                        <span style="display: table-cell; vertical-align: middle; width: 100%;">
                          Custom
                        </span>
                      </div>
                    </el-row>
                  </el-option>
                </el-select>
              </el-col>
              <!-- <el-col :span="5" class="left-aligned-col">
                <el-input value="sigmacloud.io" disabled/>
              </el-col> -->
            </el-row>
            <el-row
              v-if="!(instances && instances.length) || addingCustomInstance"
              type="flex"
              justify="start"
              align="middle"
              class="v-padded-s"
              style="padding: 10px 0;"
            >
              <el-col :span="24">
                <el-row type="flex" justify="start" align="middle" gutter="10">
                  <el-col :span="24" style="padding-bottom: 6px; font-size: 12px;">
                    Please enter an instance
                  </el-col>
                </el-row>
                <el-row type="flex" justify="start" align="middle" gutter="10">
                  <!-- <el-col :span="3">
                    <el-input value="https://" disabled />
                  </el-col> -->
                  <el-col :span="14">
                    <el-input v-model.trim="instanceField" placeholder="Instance" />
                  </el-col>
                  <!-- <el-col :span="4">
                    <el-input :value="instanceServer" disabled />
                  </el-col> -->
                  <el-col :span="2">
                    <el-button
                      type="primary"
                      @click="addInstance"
                      icon="plus"
                      />
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row type="flex" justify="start" align="middle" class="v-padded-s">
              <el-col :span="16" class="right-aligned-col">
                <div v-on:keydown="handleKeydown">
                  <el-input placeholder="e.g. johndoe" v-model="creds.username" :disabled="!instance" ref="usernameField">
                    <template slot="prepend">Username</template>
                  </el-input>
                </div>
              </el-col>
            </el-row>
            <el-row type="flex" justify="start" align="middle" class="v-padded-s">
              <el-col :span="16" class="right-aligned-col">
                <div v-on:keydown="handleKeydown">
                  <el-input placeholder="********" type="password" v-model="creds.password" :disabled="!instance">
                    <template slot="prepend">Password</template>
                  </el-input>
                </div>
              </el-col>
            </el-row>
            <el-row type="flex" justify="start" align="middle" class="v-padded-s">
              <el-col :span="8">
                <router-link to="/forgot_password">Forgot Password?</router-link>
              </el-col>
              <el-col :span="8" class="right-aligned-col">
                <el-button
                  type="primary"
                  size='small'
                  :disabled="!hasCredentials || instance === 'custom'"
                  @click="login()"
                  icon="caret-right">
                  Login
                </el-button>
              </el-col>
            </el-row>
            <el-row type="flex" justify="start" align="middle" class="v-padded-s" v-if="showSsoSection">
              <el-col :span="16" class="right-aligned-col">
                <div class="sso-section">
                  <div class="sso-title">Or continue with SSO</div>
                  <div v-if="ssoLoading" class="sso-status">Loading providers...</div>
                  <div v-else-if="ssoError" class="sso-status sso-status-error">{{ ssoError }}</div>
                  <div v-else class="sso-provider-list">
                    <el-button
                      v-for="provider in ssoProviders"
                      :key="provider.id"
                      size="small"
                      @click="startSsoLogin(provider)">
                      {{ provider.name }}
                    </el-button>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="12" style="text-align: center;">
        <SplashText></SplashText>
      </el-col>
    </el-row>
    <!-- <el-row class="terms-bottom" type="flex" justify="center" align="bottom">
      <el-col :span="4" class="right-aligned-col">
        <a class="m-left-20 blue" href="https://www.revolutiones.com/#/termsofuse" target="_blank">Terms of Use</a>
      </el-col>
      <el-col :span="4" class="right-aligned-col">
        <a class="m-left-20 blue" href="https://www.revolutiones.com/#/privacypolicy" target="_blank">Privacy Policy</a>
      </el-col>
    </el-row> -->
  </el-col>
</template>

<script>
  import SplashText from '../../SplashText.vue'
  import { mapGetters } from 'vuex'
  import isUrl from 'is-url'
  import store from '@/store/store'
  import { buildUrl } from '@/utils/api'
  import { checkForInstances, doesSiteExist } from '@/utils/helpers/SigmacloudRetiring'

  export default {
    name: 'login',
    components: { SplashText },
    data () {
      return {
        instanceField: '',
        instance: '',
        creds: { username: '', password: '' },
        addingCustomInstance: false,
        loading: false,
        ssoProviders: [],
        ssoLoading: false,
        ssoError: null
      }
    },
    methods: {
      isUrl,
      normalizeSsoProviders (responseBody) {
        let providers
        if (Array.isArray(responseBody)) {
          providers = responseBody
        } else if (responseBody && Array.isArray(responseBody.providers)) {
          providers = responseBody.providers
        } else if (responseBody && typeof responseBody === 'object') {
          providers = Object.keys(responseBody).map(key => {
            const value = responseBody[key]
            if (value && typeof value === 'object') {
              return Object.assign({}, value, { id: value.id || value.provider || value.slug || key })
            }
            return { id: key, name: String(value || key) }
          })
        } else {
          providers = []
        }

        return providers
          .map(provider => {
            if (typeof provider === 'string') {
              return { id: provider, name: provider }
            }
            if (!provider || typeof provider !== 'object') {
              return null
            }

            const id = provider.id || provider.provider || provider.slug || provider.key || provider.name
            const name = provider.display_name || provider.displayName || provider.name || provider.provider || provider.slug || id
            if (!id) return null

            return Object.assign({}, provider, { id, name })
          })
          .filter(Boolean)
      },
      async fetchSsoProviders () {
        if (!this.instance || this.instance === 'custom') {
          this.ssoProviders = []
          this.ssoError = null
          return
        }

        this.ssoLoading = true
        this.ssoError = null
        try {
          const response = await this.$http.get(buildUrl('sso/providers', null, this.instance))
          const body = response && (response.body || response.data)
          this.ssoProviders = this.normalizeSsoProviders(body)
        } catch (e) {
          this.ssoProviders = []
          this.ssoError = 'Unable to load SSO providers.'
        } finally {
          this.ssoLoading = false
        }
      },
      getSsoLoginUrl (provider) {
        const providerLoginUrl = provider.login_url || provider.loginUrl || provider.authorization_url || provider.authorizationUrl || provider.redirect_url || provider.redirectUrl || provider.url
        if (providerLoginUrl) {
          if (/^https?:\/\//i.test(providerLoginUrl)) return providerLoginUrl
          return buildUrl(providerLoginUrl.replace(/^\//, ''), null, this.instance)
        }

        const providerId = encodeURIComponent(provider.id)
        const next = encodeURIComponent(window.location.href)
        return `${buildUrl(`sso/login/${providerId}`, null, this.instance)}?next=${next}`
      },
      async startSsoLogin (provider) {
        if (!provider || !this.instance) return
        const instance = this.instances.find(v => v.url === this.instance)
        if (instance) {
          await this.$store.dispatch('switchActiveAppInstance', instance)
        }
        const redirectUrl = this.getSsoLoginUrl(provider)
        window.location.assign(redirectUrl)
      },
      getCookieValue (name) {
        const escapedName = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
        const match = document.cookie.match(new RegExp(`(?:^|; )${escapedName}=([^;]*)`))
        return match ? decodeURIComponent(match[1]) : null
      },
      clearCookie (name) {
        document.cookie = `${name}=; Max-Age=0; path=/`
      },
      getSsoCallbackToken () {
        return this.getCookieValue('token') || this.$route.query.token || this.$route.query.access_token || this.$route.query.auth_token || null
      },
      normalizeInstanceUrl (url) {
        if (!url) return null
        return url.endsWith('/') ? url : `${url}/`
      },
      getSsoCallbackInstanceUrl () {
        const queryInstance = this.$route.query.instance_url || this.$route.query.instance || this.$route.query.instances || this.$route.query.url
        if (queryInstance) {
          return this.normalizeInstanceUrl(queryInstance)
        }
        if (this.instance) {
          return this.normalizeInstanceUrl(this.instance)
        }
        if (this.activeInstance && this.activeInstance.url) {
          return this.normalizeInstanceUrl(this.activeInstance.url)
        }
        return null
      },
      async ensureSsoCallbackInstance (instanceUrl) {
        const normalizedInstanceUrl = this.normalizeInstanceUrl(instanceUrl)
        if (!normalizedInstanceUrl) return null

        let instance = this.instances.find(v => v.url === normalizedInstanceUrl)
        if (!instance) {
          await this.$store.dispatch('addInstance', normalizedInstanceUrl)
          instance = this.$store.getters.getInstances.find(v => v.url === normalizedInstanceUrl)
        }

        if (instance) {
          this.instance = instance.url
        }

        return instance
      },
      async completeSsoLogin () {
        const token = this.getSsoCallbackToken()
        if (!token) return

        const instanceUrl = this.getSsoCallbackInstanceUrl()
        if (!instanceUrl) {
          this.$message({ message: 'SSO token received, but no instance was selected.', type: 'error', duration: 10000 })
          return
        }

        try {
          this.loading = true
          const instance = await this.ensureSsoCallbackInstance(instanceUrl)
          if (!instance) {
            throw new Error(`No matching instance found for ${instanceUrl}`)
          }

          await this.$store.dispatch('switchActiveAppInstance', instance)
          await this.$store.dispatch('authenticateWithToken', { token, url: instance.url })

          if (this.$store.getters.getToken) {
            this.clearCookie('token')
            let postAuthorizationRoute
            if (this.logoutNotifMsg) {
              this.$store.dispatch('setLogoutNotifMsg', '')
            }
            if (this.postAuthorizationRoute) {
              postAuthorizationRoute = this.postAuthorizationRoute
              this.$store.dispatch('setPostAuthorizationRoute', null)
            }
            return this.$router.replace(postAuthorizationRoute ? { name: postAuthorizationRoute } : '/home')
          }
        } catch (e) {
          console.log(e)
          this.clearCookie('token')
          this.$store.dispatch('resetAuthFailure')
          this.$message({ message: 'Unable to login with the SSO token.', type: 'error', duration: 10000 })
        } finally {
          this.loading = false
        }
      },
      /*
      * Adds an instance manually, sets it as active, and calls login()
      * @return void
      */
      async addInstance () {
        try {
          let field
          let exp = new RegExp(`^(https:\\/\\/)?([a-zA-Z0-9_-]+)(.pa.revolutiones.com/)?\\/?$`, 'i')
          if (this.instanceField.includes('127.0.0') || this.instanceField.includes('localhost') || this.instanceField.includes('https') || this.instanceField.includes('http')) {
            field = this.instanceField
            if (!await doesSiteExist(field)) {
              this.$message({ message: 'The instance URL you provided does not appear to be exist. Please check the URL and try again.', type: 'error', duration: 10000 })
              return
            }
          } else {
            field = this.instanceField.match('.pa.revolutiones.com/') ? this.instanceField : (this.instanceField.match('https://') ? '' : 'https://') + this.instanceField.replace(exp, '$2') + '.pa.revolutiones.com/'
            if (field[field.length - 1] !== '/') field = field + '/'
            if (!await doesSiteExist(field)) {
              field = 'https://' + this.instanceField.replace(exp, '$2') + '.pa.probooks.revolutiones.org/'
              if (field[field.length - 1] !== '/') field = field + '/'
              if (!await doesSiteExist(field)) {
                this.$message({ message: 'The instance URL you provided does not appear to be exist. Please check the URL and try again.', type: 'error', duration: 10000 })
                return
              }
            }
          }
          const url = await this.$store.dispatch('addInstance', field, this.instanceField.replace(exp, '$2'))
          this.handleInstanceSelect(url)
          this.instanceField = ''
          this.addingCustomInstance = false
          setTimeout(() => this.focusOnUsernameField())
        } catch (e) {
          console.log(e)
        }
      },
      /**
       * Finds the username field and focuses on it
       */
      focusOnUsernameField () {
        if (this.$refs && this.$refs.usernameField && this.$refs.usernameField.$el) {
          const inputEl = [...this.$refs.usernameField.$el.children].find(child => child.tagName === 'INPUT')
          if (inputEl) {
            inputEl.focus()
          }
        }
      },
      /*
      * Removes an instance
      * @param {url} URL of instance to remove
      * @return void
      */
      async removeInstance (url) {
        await this.$store.dispatch('removeInstance', url)
        setTimeout(() => {
          if (this.activeInstance && this.activeInstance.url) {
            this.handleInstanceSelect(this.activeInstance.url)
          } else {
            this.handleInstanceSelect()
          }
        })
      },
      /*
      * Sets a selected instance
      * @param {i} selected instance url
      * @return void
      */
      handleInstanceSelect (url = null) {
        if (url) {
          const instance = this.instances.find(v => v.url === url)
          this.instance = instance && instance.url ? instance.url : ''
        } else {
          this.instance = ''
        }
      },
      /*
      * Logs the user in. First, sets the selected instance as the currently active instance.
      * @return void
      */
      async login () {
        try {
          this.loading = true
          const instance = this.instances.find(instance => instance.url === this.instance)
          await this.$store.dispatch('clearState')
          await this.$store.dispatch('switchActiveAppInstance', instance)
          const { username, password } = this.creds
          const payload = { username, password, url: this.activeInstance.url }
          await this.$store.dispatch('authenticate', payload)
          if (this.$store.getters.getToken) {
            let postAuthorizationRoute
            if (this.logoutNotifMsg) {
              this.$store.dispatch('setLogoutNotifMsg', '')
            }
            if (this.postAuthorizationRoute) {
              postAuthorizationRoute = this.postAuthorizationRoute
              this.$store.dispatch('setPostAuthorizationRoute', null)
            }
            return this.$router.push(postAuthorizationRoute ? { name: postAuthorizationRoute } : '/home')
          }
          this.loading = false
        } catch (e) {
          console.log(e)
          this.creds.username = ''
          this.creds.password = ''
          this.addingCustomInstance = false
          this.loading = false
          this.$store.dispatch('resetAuthFailure')
        }
      },
      /*
      * Calls login() when user presses the enter key
      * @return void
      */
      handleKeydown (e) {
        if (e && e.keyCode === 13) {
          this.validInstanceUrl ? this.addInstance() : this.login()
        }
      },
      /*
      * If this.logoutNotifMsg is set, displays that message as a notification
      * @return void
      */
      displayLogoutMsg () {
        if (this.logoutNotifMsg) this.$message({ message: this.logoutNotifMsg, type: 'warning', duration: 8000 })
      },
      /*
      * Displays authentication error
      * @return void
      */
      displayAuthError () {
        this.$message({ message: this.authFailure, type: 'error', duration: 10000 })
      },
      /*
      * Called in create hook. Checks if instances exist, and if so, finds the active one.
      * If none are active, sets the instance at index 0 as active
      * @return void
      */
      async findOrSetActiveInstance () {
        if (this.instances.length) {
          if (this.activeInstance && this.activeInstance.url) {
            this.instance = this.activeInstance.url
          } else {
            await this.$store.dispatch('clearState')
            this.$store.dispatch('switchActiveAppInstance', this.instances[0])
            this.instance = this.instances[0].url
          }
        }
      }
    },
    computed: {
      ...mapGetters({
        authFailure: 'getAuthFailure',
        activeInstance: 'getActiveInstance',
        instances: 'getInstances',
        instanceServer: 'getInstanceServer',
        postAuthorizationRoute: 'getPostAuthorizationRoute',
        logoutNotifMsg: 'getLogoutNotifMsg'
      }),
      sortedInstances () {
        if (!this.instances || !this.instances.length) return []
        return this.instances.slice().sort((a, b) => {
          if (a.name && b.name) {
            return a.name.localeCompare(b.name)
          } else if (a.name && !b.name) {
            return -1
          } else if (!a.name && b.name) {
            return 1
          } else {
            return a.url.localeCompare(b.url)
          }
        })
      },
      /*
      * Checks if user credentials are set
      * @return boolean
      */
      hasCredentials () {
        return !!(this.creds.username && this.creds.password)
      },
      /**
       * Determines whether the instance URL provided is valid
       */
      validInstanceUrl () {
        return this.instanceField.includes('localhost') || isUrl(this.instanceField)
      },
      showSsoSection () {
        return !!this.instance && this.instance !== 'custom' && !this.ssoLoading && !this.ssoError && this.ssoProviders.length > 0
      }
    },
    watch: {
      authFailure () {
        if (this.authFailure) {
          this.displayAuthError()
        }
      },
      instance () {
        this.fetchSsoProviders()
      }
    },
    created () {
      this.displayLogoutMsg()
      this.findOrSetActiveInstance()

      // If being redirected with existing sessions, try to import into our localStorage "instances"
      if (checkForInstances(this.$route.query, store)) {
        this.$router.push({ query: null })
        this.$notify({ title: 'ProBooks has been updated', message: 'Please update your bookmarks to "https://probooks.revolutiones.com".', type: 'warning' })
      }

      this.completeSsoLogin()
    },
    async beforeRouteEnter (to, from, next) {
      // Redirect if trying to access app.sigmacloud.io
      // checkForOldFrontend()

      await store.dispatch('verifyAuth')
      if (from.path === '/') {
        return next()
      }
      try {
        if (to.query.hasOwnProperty('instances') && Object.keys(to.query.instances).length) {
          await store.dispatch('fetchInstances', to.query.instances)
        } else {
          await store.dispatch('fetchInstances')
        }
      } catch (e) {
        console.log(e)
      } finally {
        next()
      }
    }
  }
</script>

<style scoped>
  #login {
    padding: 60px 0;
    background-color: #ffffff;
  }
  .left-aligned-col {
    text-align: left;
  }
  .right-aligned-col {
    text-align: right;
  }
  .login-form-wrapper h3 {
    padding: 12px 0;
  }
  .left-padded {
    padding-left: 12px;
  }
  .v-padded-s {
    padding: 6px 0;
  }
  .login-row {
    color: #324157;
  }
  #password {
    padding: 12px 0;
  }
  #login-register-btn-wrapper {
    padding: 12px 0;
  }
  .sso-section {
    padding-top: 8px;
    text-align: right;
  }
  .sso-title {
    font-size: 12px;
    color: #606266;
    margin-bottom: 6px;
  }
  .sso-provider-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 6px;
  }
  .sso-status {
    font-size: 12px;
    color: #909399;
  }
  .sso-status-error {
    color: #f56c6c;
  }
  .terms-bottom {
    position: absolute;
    bottom: 10px;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/RouteComponents/Auth/Login.vue